import React from 'react';

import Content from '../../../Content';

import {IPersonalizedItemProps} from './IPersonalizedItem';

// @todo: try to get the items with the parent block in the same query
const PersonalizedItem = ({personalizedItem}: IPersonalizedItemProps) => {
	// If we already have the item
	if (personalizedItem?.item) {
		return <Content data={personalizedItem.item} />;
	}

	return <></>;
};

export default PersonalizedItem;
